import BigNumber from 'bignumber.js'

import { Ordering } from '@blade/std-lib'

export const Up = 'up' as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Up = typeof Up
export const Down = 'down' as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Down = typeof Down
export const Neutral = 'neutral' as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Neutral = typeof Neutral

export type Trend = Up | Down | Neutral

export const of = (value: number | BigNumber): Trend => {
  if (BigNumber.isBigNumber(value)) {
    if (value.isZero()) {
      return Neutral
    }
    return value.lt(0) ? Down : Up
  }

  if (value === 0) {
    return Neutral
  }

  return value < 0 ? Down : Up
}

export const match = <U, D, N>(
  trend: Trend,
  on: { Up: () => U; Down: () => D; Neutral: () => N },
): U | D | N => {
  switch (trend) {
    case Up: {
      return on.Up()
    }
    case Down: {
      return on.Down()
    }
    case Neutral: {
      return on.Neutral()
    }
  }
}

export const fromOrdering = (ordering: Ordering.Ordering): Trend => {
  return Ordering.match(ordering, {
    onLessThan: () => Down,
    onEqual: () => Neutral,
    onGreaterThan: () => Up,
  })
}
